// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Lx7En","name":"Header_name__3KjSB","birthday":"Header_birthday__20H1f","skeleton":"Header_skeleton__3tziy"};